import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription, timer } from 'rxjs'
import { slideshowAnimation } from './slideshow.animations'
@Component({
  selector: 'app-infographic-slider',
  templateUrl: './infographic-slider.component.html',
  styleUrls: ['./infographic-slider.component.less'],
  animations: [slideshowAnimation],
})
export class InfographicSliderComponent implements OnInit, OnDestroy, AfterViewInit {
  activeSlide = 0
  maxSlide = 3
  timerSubscription!: Subscription
  currentDirection = 'left'
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.startSlideShow()
  }

  startSlideShow() {
    const source = timer(0, 4500)
    this.timerSubscription = source.subscribe({
      next: (val: any) => {
        if (this.activeSlide < this.maxSlide) {
          this.activeSlide += 1
        } else if (this.activeSlide === this.maxSlide) {
          this.activeSlide = 1
        }
      },
    })
  }

  ngOnDestroy() {
    this.timerSubscription.unsubscribe()
  }
}
